
import React, { useState, useEffect } from "react";
import IntroScreen from "@/components/IntroScreen";
import EstimationTool from "@/components/EstimationTool";

const Index = () => {
  const [showIntro, setShowIntro] = useState(true);
  
  useEffect(() => {
    // Check for dark mode preference
    const isDarkMode = localStorage.getItem("theme") === "dark" || 
      (!localStorage.getItem("theme") && window.matchMedia("(prefers-color-scheme: dark)").matches);
    
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white dark:from-blue-950 dark:to-blue-900">
      {showIntro ? (
        <IntroScreen onGetStarted={() => setShowIntro(false)} />
      ) : (
        <EstimationTool onBackToIntro={() => setShowIntro(true)} />
      )}
    </div>
  );
};

export default Index;
